import {
  WorkflowLogEntry,
  WorkflowLogEntryResponse,
} from '../../models/workflow-history.model';

export function mapLogResponseToModel(
  response: WorkflowLogEntryResponse,
): WorkflowLogEntry {
  const jobStatus = [
    response.jobStatus,
    response.status,
    response.additionalData?.['status'],
  ].find((value): value is string => typeof value === 'string' && !!value.trim());

  return {
    ...response,
    jobStatus: jobStatus?.trim() || '',
    timestamp: new Date(response.timestamp).toString(),
    timestampDate: new Date(response.timestamp),
  };
}
